"use client";

import React from "react";
const galleryItems = [{
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/petal_garden_morning_dew.png",
  alt: "Close-up of morning dew on a fresh garden rose"
}, {
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/petal_boutique_interior.png",
  alt: "Minimalist boutique interior with curated floral displays"
}, {
  type: "quote",
  text: "A garden is a slow-motion dance between the earth and the sun, captured in a single bloom.",
  author: "The PETAL Philosophy"
}, {
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/petal_seasonal_bouquet.png",
  alt: "Artisanal seasonal bouquet with sage and dusty rose tones"
}, {
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/petal_garden_pathway.png",
  alt: "Serene stone pathway through the cultivated garden spaces"
}, {
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/petal_floral_artistry.png",
  alt: "Detailed view of a high-fashion floral arrangement"
}, {
  type: "image",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/petal_sunset_harvest.png",
  alt: "Sun-drenched garden during the golden hour harvest"
}];
export default function SacredMoments() {
  return <section data-section-id="224795" id="our-living-sanctuary" className="py-20 md:py-32 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 md:mb-24 text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-default font-light text-primary mb-6 tracking-wider">
            Our Living Sanctuary
          </h2>
          <p className="text-foreground/80 font-sans text-lg md:text-xl leading-relaxed">
            Explore the organic beauty of our cultivated gardens and the 
            refined artistry of our boutique floral studio.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {galleryItems.map((item, i) => <div key={i} data-index={i} className="break-inside-avoid">
              {item.type === "quote" ? <div className="bg-secondary aspect-square flex flex-col items-center justify-center p-8 md:p-12 text-center relative overflow-hidden group shadow-md rounded-md">
                  <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out" />
                  <p className="font-serif text-primary text-2xl md:text-3xl lg:text-4xl leading-snug mb-8 relative z-10 font-medium">
                    "{item.text}"
                  </p>
                  <span className="font-sans text-primary/70 text-xs md:text-sm tracking-widest uppercase relative z-10">
                    {item.author}
                  </span>
                </div> : <div className="relative overflow-hidden group bg-muted shadow-md rounded-md">
                  <img src={item.src} alt={item.alt} className="w-full h-auto object-cover transition-transform duration-1000 ease-out group-hover:scale-105" loading="lazy" />
                  <div className="absolute inset-0 bg-accent/0 group-hover:bg-accent/20 transition-colors duration-1000 ease-out pointer-events-none" />
                  <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-background/80 backdrop-blur-sm px-3 py-1 rounded-md">
                    <span className="text-[10px] uppercase tracking-widest font-sans text-primary">Spring Bloom</span>
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}